export default "__VITE_ASSET__CGGn6TFL__"